import React from 'react';
import './Galery.css';
import g1 from '../images/g1.jpg';
import g2 from '../images/g2.jpg';
import g3 from '../images/g3.jpg';

class Galery extends React.Component {
  render() {
    return (
      <div className="galery jumbotron-fluid">
        <div id="demo" className="carousel slide" data-ride="carousel" data-interval="false">
          <ul className="carousel-indicators">
            <li data-target="#demo" data-slide-to="0" className="active"></li>
            <li data-target="#demo" data-slide-to="1"></li>
            <li data-target="#demo" data-slide-to="2"></li>
          </ul>
          <div className="carousel-inner">
            <div className="carousel-item active">
              <img src={g1} alt="Los Angeles" width="1100" height="500" />
              <div className="carousel-title">
                <h1>
                  <span>Ga</span>leri
                </h1>
              </div>
              <div className="carousel-caption">
                <h1>"Bepergian adalah satu-satunya hal yang Anda beli, yang membuat Anda lebih kaya"</h1>
                <p>- Anonymous -</p>
              </div>
            </div>
            <div className="carousel-item">
              <img src={g2} alt="Chicago" width="1100" height="500" />
              <div className="carousel-title">
                <h1>
                  Ga<span>le</span>ri
                </h1>
              </div>
              <div className="carousel-caption">
                <h1>"Aku sadar bahwa pergi berpetualang adalah cara terbaik untuk belajar"</h1>
                <p>- Traveller -</p>
              </div>
            </div>
            <div className="carousel-item">
              <img src={g3} alt="New York" width="1100" height="500" />
              <div className="carousel-title">
                <h1>
                  Gale<span>ri</span>
                </h1>
              </div>
              <div className="carousel-caption">
                <h1>"Tujuan bukanlah sebuah tempat, namun sebuah cara pandang baru"</h1>
                <p>- Human -</p>
              </div>
            </div>
          </div>
          <a className="carousel-control-prev" href="#demo" data-slide="prev">
            <span className="carousel-control-prev-icon"></span>
          </a>
          <a className="carousel-control-next" href="#demo" data-slide="next">
            <span className="carousel-control-next-icon"></span>
          </a>
        </div>
      </div>
    );
  }
}

export default Galery;
